<template>
    <div>
        <!--面包屑-->
        <p class="breadcrumb">MANAGE RELATIONS</p>
        <!--上方操作框-->
        <el-row type="flex" class="row-bg p-10 mt-10 bg-lightgarg" justify="space-between">
            <el-col :span="5" class="mr-10" style="min-width: 232px;">
                <el-select v-model="selectTeacherValue" filterable placeholder="Please choose a teacher first" @change="changeTeacherId"
                           style="width: 100%;" no-match-text="No data" no-data-text="No data">
                    <el-option
                            v-for="item in teachers"
                            :key="item.id"
                            :label="item.displayName +' - '+ item.givenName +' '+ item.familyName"
                            :value="item.displayName"
                    >
                    </el-option>
                </el-select>
            </el-col>
            <el-col :span="8">
                <el-select v-model="selecttripvalue"  clearable placeholder="Trip" :disabled="!selectTeacherValue"
                           class="input-setMaxWidth select-bg-s" no-match-text="No data" no-data-text="No data" style="width: 100%;">
                    <el-option
                            v-for="item in options"
                            :label="item.name"
                            :key="item.id"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-col>
            <el-col :span="11"></el-col>
        </el-row>

        <!--穿梭框 -->
        <transfer-box :selecttripvalue="selecttripvalue" :t-id="teacherId"></transfer-box>

    </div>
</template>
<script>
    import TransferBox from '../common/TransferBox.vue';

    export default {
        components: {
            "transfer-box": TransferBox
        },
        data() {
            return {
                selecttripvalue: '',
                selectTeacherValue: '',
                // 教师数据----
                teacherId: '',
                teachers: [],
                currentPage: 1,
                totalPages: 1,
                loading: true,
                //----教师数据
                options:[],
                size: 500 // 现在设为200，是为了获取全部教师数据
            }
        },
        created() {
            this.getusers();
            this.selectTrip();
        },
        methods: {
            //获取trip列表
            selectTrip(){
                this.$http.get('trip/list').then(response => {
                    this.options = response;
                }).catch(error => {
                    this.$message.error(error.message)
                })
            },
            //获取教师列表通用函数
            getusers(){
                this.loading = true;
                // 请求教师接口query数据
                var teacherQuery = {
                        role: 'sata',
                        trashed: 0,
                        // page: this.currentPage,
                        tripId: this.selecttripvalue,
                        // keywords: '',
                        size: this.size
                }
                this.$http.get('user', {
                    // params => 用于设置请求头query数据
                    params: teacherQuery
                })
                .then(response => {
                    //渲染数据
                    this.teachers = response.list;
                    this.totalPages = response.totalPages;
                }).catch(error => {
                    this.$message.error(error.message)
                })
            },
            changeTeacherId(currentTeacherName) {
                var teacher = this.teachers.filter((value) => {
                    return value['displayName'] === currentTeacherName;
                })
                this.teacherId = teacher[0]['id'];
            }
        }
    }
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// Relation.vue?1de66e60